import { axios } from "utils";
export const getPaymentsReports = (query = "") =>
  axios.get("/reports/payments" + query).then((res) => res.data?.docs);

export const getReservationsReports = (query = "") =>
  axios.get("/reports/reservations" + query).then((res) => res.data?.docs);

export const getReservationsByEducators = (query = "") =>
  axios.get("/reports/reservations/byEducators" + query).then(res => res?.data?.docs)